/**
 * DevExtreme (esm/ui/data_grid/ui.data_grid.js)
 * Version: 22.1.4
 * Build date: Fri Jul 22 2022
 *
 * Copyright (c) 2012 - 2022 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */
import DataGrid from "./ui.data_grid.base";
export default DataGrid;
import "./ui.data_grid.state_storing";
import "./ui.data_grid.selection";
import "./ui.data_grid.column_chooser";
import "./ui.data_grid.grouping";
import "./ui.data_grid.master_detail";
import "./ui.data_grid.editing";
import "./ui.data_grid.editing_row_based";
import "./ui.data_grid.editing_form_based";
import "./ui.data_grid.editing_cell_based";
import "./ui.data_grid.validating";
import "./ui.data_grid.virtual_scrolling";
import "./ui.data_grid.filter_row";
import "./ui.data_grid.header_filter";
import "./ui.data_grid.filter_sync";
import "./ui.data_grid.filter_builder";
import "./ui.data_grid.filter_panel";
import "./ui.data_grid.search";
import "./ui.data_grid.pager";
import "./ui.data_grid.columns_resizing_reordering";
import "./ui.data_grid.keyboard_navigation";
import "./ui.data_grid.summary";
import "./ui.data_grid.column_fixing";
import "./ui.data_grid.adaptivity";
import "./ui.data_grid.virtual_columns";
import "./ui.data_grid.export";
import "./ui.data_grid.focus";
import "./ui.data_grid.row_dragging";
